// H:\APP_REACT\CIFRA\src\routes.js
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SplashScreen from "./Pages/SplashScreen";
import { PrivateRoutes } from "./Security/PrivateRoutes";
import PanelRoutes from "./Security/PanelRoutes";

/**
 * Árbol de rutas de la app. Se exporta sin `BrowserRouter` propio: quien lo
 * usa (`App.js`) es dueño del Router, porque necesita leer la ruta activa
 * con `useLocation` para decidir si muestra el Header/Footer clásico o deja
 * el mapa a pantalla completa sin ellos.
 */
function AppRoutes() {
  return (
    <Routes>
      {/* Ruta para el Splash Screen */}
      <Route path="/splash" element={<SplashScreen />} />

      {/* Panel de personal municipal (HU-003) — login + rutas con guard de rol */}
      <Route path="/panel/*" element={<PanelRoutes />} />

      {/* Rutas protegidas */}
      <Route path="/*" element={<PrivateRoutes />} />

      {/* Al iniciar la app se redirige a la pantalla de splash */}
      <Route index element={<Navigate to="/splash" replace />} />
    </Routes>
  );
}

export { AppRoutes };
